import React from 'react';
import { useSideBar } from './SideBarContext';
import useMediaQuery from '../../hooks/useMediaQuery';

const SideBarTrigger = React.forwardRef(({ className = '', ...props }, ref) => {
  const { toggleMobileSidebar } = useSideBar();
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  if (isDesktop) return null;

  return (
    <button
      ref={ref}
      onClick={toggleMobileSidebar}
      aria-label="Abrir menú"
      className={`inline-flex items-center justify-center w-10 h-10 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 transition-colors ${className}`}
      {...props}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
      </svg>
    </button>
  );
});

SideBarTrigger.displayName = 'SideBarTrigger';
export default SideBarTrigger;
